<div class="account-review-dashboard-container container pt-3">
  <div class="row">
    <div class="col-12 col-lg-4">
      <app-open-records-table
        [gridSummaryRes]="openRecords"
        [navLink]="'/account-review'"
        [relatedGridName]="'AccountReviewGridFilters'"
        [statusFilter]="'ReviewStatus'"
      ></app-open-records-table>
    </div>

    <div class="col-12 col-lg-8 aging-cases-container">
      <app-aging-cases-table [cases]="agingCases"></app-aging-cases-table>
    </div>
  </div>
</div>
